module.exports = __webpack_public_path__ + "img/zhihu-circle.0b8618aa.svg";